/* eslint-disable react/prop-types */
import { Cancel } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tab,
  Tabs,
  useMediaQuery,
} from "@mui/material";
import theme from "assets/theme";
import useAxiosPrivate from "hooks/useAxiosPrivate";
import { useEffect, useMemo, useRef, useState } from "react";
import { useRecoilValue, useRecoilState } from "recoil";
import { AlertState, SettingState } from "states";
import CustomFieldForm from "../../components/CustomFieldForm";
import {
  API_ROUTES,
  PaperComponent,
  validateArrayFileRequired,
} from "../../utils/constants";
import dayjs from "dayjs";
import AddListFile from "components/AddListFile";
import CustomTabPanel from "components/CustomPanel/customPanel";
import { JsonTool } from "utils/jsonTools";
import BusinessIcon from "@mui/icons-material/Business";
import ArticleIcon from "@mui/icons-material/Article";

const defaultValue = {
  nam: new Date(),
  chuthe: null,
  landanhgia: 1,
  ngaydanhgia: null,
  noidung: "",
  sanpham: null,
  username: null,
  hoidong: null,
};

const FormDangKySanPham = ({
  data,
  open,
  onClose,
  onSubmit,
  title,
  validationErrors,
  action,
  dataChuThe,
  inforChuThe,
  isShowHoiDong,
  dataHoiDong,
  sanPhamSelect,
}) => {
  // state lỗi giá trị từ form
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const formRef = useRef(null);
  const axiosPrivateInstance = useAxiosPrivate();
  const [errors, setErrors] = useState();
  const [dataState, setDataState] = useState(defaultValue);
  const [alert, setAlert] = useRecoilState(AlertState);
  const [value, setValue] = useState(0);
  const [optionSanPham, setOptionSanPham] = useState([]);
  const settingState = useRecoilValue(SettingState);
  //state file
  const [fileDel, setFileDel] = useState([]);
  const [fileFields, setFileFields] = useState([]);
  const [fileEditName, setFileEditName] = useState({});
  //change
  const getSanPham = (idChuThe) => {
    axiosPrivateInstance
      .get(API_ROUTES.SANPHAM, { params: { chuthe: idChuThe } })
      .then((res) => {
        setOptionSanPham(res?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleChangeChuThe = (e, newValue) => {
    setDataState((prev) => {
      return {
        ...prev,
        chuthe: newValue ? newValue.id : null,
        sanpham: null,
      };
    });
    newValue.id && getSanPham(newValue.id);
  };
  const fieldInfor = useMemo(() => {
    let result = [
      {
        name: "Năm",
        key: "nam",
        type: "dateYear",
        required: true,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Chủ thể",
        key: "chuthe",
        type: "autocomplete",
        unicode: "id",
        required: true,
        hasPlaceholder: true,
        labelKeyOption: "ten",
        isHidden: inforChuThe && inforChuThe.id ? true : false,
        readOnly: sanPhamSelect?.idChuThe ? true : false,
        onChange: handleChangeChuThe,
        xs: 9,
        md: 8,
        lg: 8,
      },
      {
        name: "Sản phẩm",
        key: "sanpham",
        type: "select",
        unicode: "id",
        required: true,
        hasPlaceholder: true,
        labelKeyOption: "ten",
        xs: 12,
        md: inforChuThe && inforChuThe.id ? 8 : 12,
        lg: inforChuThe && inforChuThe.id ? 8 : 12,
        readOnly: sanPhamSelect?.idChuThe ? true : false,
      },
      {
        name: "Lần đánh giá",
        key: "landanhgia",
        type: "select",
        unicode: "id",
        required: true,
        hasPlaceholder: true,
        labelKeyOption: "ten",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Ngày đánh giá",
        key: "ngaydanhgia",
        type: "date",
        required: true,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Sản phẩm mẫu",
        key: "sanphammau",
        type: "number",
        required: true,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Nội dung",
        key: "noidung",
        type: "textArea",
        required: true,
        maxLength: 255,
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        name: "Hội đồng",
        key: "hoidong",
        type: "select",
        unicode: "id",
        required: true,
        hasPlaceholder: true,
        labelKeyOption: "soquyetdinh",
        isHidden: !isShowHoiDong,
        xs: 12,
        md: 12,
        lg: 12,
      },
    ];
    return result;
  }, [inforChuThe, isShowHoiDong, sanPhamSelect]);

  useEffect(() => {
    if (data && data.id) {
      const year = new Date();
      year.setFullYear(data?.nam);
      let dataConvert = { ...data, nam: year };
      if (data && data.chuthe) {
        getSanPham(data.chuthe);
      }
      if (isShowHoiDong && data.chamdiem?.length > 0) {
        dataConvert["hoidong"] = data.chamdiem[0]?.hoidong_id;
      } else {
        dataConvert["hoidong"] = null;
      }
      setDataState(dataConvert);
    } else {
      const defaultNew = {
        ...defaultValue,
        chuthe: inforChuThe?.id,
      };
      let values = { ...defaultNew };
      if (
        (action == "New" && sanPhamSelect?.idSanPham, sanPhamSelect?.idChuThe)
      ) {
        values = {
          ...defaultNew,
          sanpham: sanPhamSelect?.idSanPham,
          chuthe: sanPhamSelect?.idChuThe,
          landanhgia: 3,
        };
      }
      setDataState(values);
      if ((inforChuThe && inforChuThe.id) || sanPhamSelect?.idChuThe) {
        let id = inforChuThe?.id;
        if (!id) {
          id = sanPhamSelect?.idChuThe;
        }
        getSanPham(id);
      }
    }
  }, [data, inforChuThe, isShowHoiDong, action, sanPhamSelect]);

  async function onSubmitForm(event) {
    event.preventDefault();
    const namValue =
      dataState?.nam && dayjs(dataState?.nam)?.isValid()
        ? dayjs(dataState?.nam)?.get("year")
        : "";
    const _data = { ...dataState, nam: namValue };
    if (action == "Edit") {
      delete _data["tepdinhkem_phieudangky"];
      _data["fileDel"] = fileDel;
      _data["id"] = data?.id;
      _data["rowIndex"] = data?.rowIndex;
    }
    const usernameChuThe =
      inforChuThe && inforChuThe.id
        ? inforChuThe?.username
        : dataChuThe?.find((item) => item?.id == dataState?.chuthe)?.username;
    _data["username"] = usernameChuThe;
    const listFormatDate = ["ngaydanhgia"];
    listFormatDate?.forEach((field) => {
      _data[field] =
        dataState?.[field] &&
        !errors?.[field] &&
        dayjs(dataState?.[field])?.isValid()
          ? dayjs(dataState?.[field]).format("YYYY-MM-DD")
          : null;
    });
    if (!isShowHoiDong) {
      _data["hoidong"] = "";
    }
    _data["tentepdinhkem"] = fileFields?.map((item) => item?.filename) || [];
    _data["tepdinhkemValidate"] = fileFields?.map((item) => item?.file) || [];
    _data["tentepdinhkemEdit"] = Object.values(fileEditName);
    const newValidationErrors = validateOBJ(
      _data,
      isShowHoiDong,
      settingState["dungluong_file_upload"]
    );
    let _tempValid = newValidationErrors;
    if (
      _tempValid["tepdinhkemValidate"] &&
      _tempValid["tepdinhkemValidate"].some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return;
    }
    if (
      _tempValid["tentepdinhkem"] &&
      _tempValid["tentepdinhkem"].some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return;
    }

    if (
      _tempValid["tentepdinhkemEdit"] &&
      Object.values(_tempValid["tentepdinhkemEdit"])?.length > 0 &&
      Object.values(_tempValid["tentepdinhkemEdit"]).some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return;
    }

    delete _tempValid["tentepdinhkem"];
    delete _tempValid["tepdinhkemValidate"];
    delete _tempValid["tentepdinhkemEdit"];
    delete _data["tepdinhkemValidate"];
    if (Object.values(_tempValid).some((error) => error)) {
      setErrors((prev) => ({
        ...prev,
        ...newValidationErrors,
      }));
      return;
    }
    let listName = [];
    fileFields?.forEach((item) => {
      if (!item?.remove) {
        listName.push(item?.filename);
      }
    });
    _data["tentepdinhkem"] = listName;
    _data["tepdinhkem"] = fileFields?.map((item) => item?.file) || [];
    onSubmit(_data);
  }

  const handelClear = () => {
    onClose();
  };

  useEffect(() => {
    if (validationErrors?.another) {
      setAlert({
        alert: true,
        message: validationErrors?.another,
        type: "error",
      });
    } else {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  useEffect(() => {
    if (open) {
      setErrors({});
      setValue(0);
      setFileDel([]);
      setFileFields([]);
      setFileEditName({});
    }
  }, [open]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeDataState = (data) => {
    let { name, value } = data;
    setDataState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleErrorDataState = (error) => {
    let { name, value } = error;
    setErrors((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  //change file
  const handleErrorDownload = (error) => {
    setAlert(error);
  };
  const handleOnDeleteFileDefault = (data) => {
    setFileDel(data);
  };
  const handleErrorFile = (error) => {
    setErrors(error);
  };
  const handleChangeFileList = (data) => {
    setFileFields(data);
  };
  const handleEditFileNameDefault = (data) => {
    setFileEditName(data);
  };
  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      PaperComponent={PaperComponent}
      onClose={handelClear}
      scroll="paper"
      PaperProps={{
        sx: {
          "@media (min-width: 768px)": {
            minWidth: "40rem",
          },
          height: "100%",
        },
      }}
    >
      {/* Form*/}
      <form
        ref={formRef}
        method="post"
        encType="multipart/form-data"
        style={{
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          height: "100%",
        }}
      >
        {/* Tiêu đề modal - tham số title */}
        <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#ffffff" }}>
          {title ? title : "Chỉnh sửa sản phẩm"}
          <IconButton
            aria-label="close"
            onClick={handelClear}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ overflow: "auto", paddingTop: "0" }}>
          <Box>
            {/* show lỗi từ khi không xác định được từ các field ở form */}
            {errors && errors.error ? (
              <Grid container sx={{ textAlign: "center", mb: 0 }}>
                <Grid item xs={12}>
                  <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                    {errors.error}
                  </Alert>
                </Grid>
              </Grid>
            ) : (
              ""
            )}
            <Box
              sx={{
                width: "100%",
                bgcolor: "background.paper",
                //borderBottom: 1,
                borderColor: "divider",
                padding: "0 1rem",
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="secondary"
                textColor="primary"
                variant="fullWidth"
                aria-label="basic tabs example"
              >
                <Tab
                  icon={<BusinessIcon />}
                  label="Thông tin"
                  {...JsonTool.a11yProps(0)}
                />
                <Tab
                  icon={<ArticleIcon />}
                  label="Tệp đính kèm"
                  {...JsonTool.a11yProps(1)}
                />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              {fieldInfor?.length > 0 && (
                <CustomFieldForm
                  key={"fieldInfor"}
                  listField={fieldInfor}
                  data={dataState}
                  onChange={handleChangeDataState}
                  onError={handleErrorDataState}
                  errorValues={errors}
                  listOptionDic={{
                    chuthe: dataChuThe?.slice(1),
                    sanpham: optionSanPham,
                    landanhgia: [
                      { id: 1, ten: "Lần đầu" },
                      { id: 2, ten: "Nâng hạng" },
                      { id: 3, ten: "Đánh giá lại" },
                    ],
                    hoidong: dataHoiDong,
                  }}
                />
              )}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <AddListFile
                dataDefault={data?.tepdinhkem_phieudangky}
                fileDel={fileDel}
                fileEditName={fileEditName}
                fileFields={fileFields}
                errors={errors}
                onDelete={handleOnDeleteFileDefault}
                onError={handleErrorFile}
                onFileChange={handleChangeFileList}
                nameFile="phieudangky"
                onEditName={handleEditFileNameDefault}
                onErrorDownload={handleErrorDownload}
              />
            </CustomTabPanel>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            type="button"
            variant="contained"
            startIcon={<Cancel />}
            size="small"
            onClick={handelClear}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Hủy
          </Button>
          <Button
            type="submit"
            variant="contained"
            startIcon={<SaveIcon />}
            size="small"
            onClick={onSubmitForm}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Lưu
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

const validateRequired = (value) => {
  let result = !!value?.length;
  if (typeof value == "number") {
    result = true;
  }
  return result;
};
const validateArrayRequired = (arrayValue) => {
  let result = [];
  if (arrayValue) {
    arrayValue.map((value, index) => {
      result.push("");
      if (!value?.length) result[index] = "Tên tệp không được trống";
    });
  }
  return result;
};
const validateFileEditName = (arrayValue) => {
  let result = {};
  if (arrayValue) {
    arrayValue.map((file, index) => {
      result[file?.id] = "";
      if (!file?.tentepdinhkem) result[file?.id] = "Tên tệp không được trống";
    });
  }
  return result;
};

function validateOBJ(dksp, isShowHoiDong, dungluong) {
  let result = {
    chuthe: !validateRequired(dksp.chuthe) ? "Chọn chủ thể" : "",
    nam: !validateRequired(dksp.nam) ? "Chọn năm" : "",
    landanhgia: !validateRequired(dksp.landanhgia) ? "Chọn lần đánh giá" : "",
    ngaydanhgia: !validateRequired(dksp.ngaydanhgia)
      ? "Ngày đánh giá trống hoặc sai định dạng"
      : "",
    sanpham: !validateRequired(dksp.sanpham) ? "Chọn sản phẩm" : "",
    noidung: !validateRequired(dksp.noidung) ? "Nhập nội dung" : "",
    tentepdinhkem: validateArrayRequired(dksp.tentepdinhkem),
    tepdinhkemValidate: validateArrayFileRequired(
      dksp.tepdinhkemValidate,
      dungluong
    ),
    tentepdinhkemEdit: validateFileEditName(dksp.tentepdinhkemEdit),
    hoidong: isShowHoiDong
      ? !validateRequired(dksp.hoidong)
        ? "Chọn hội đồng"
        : ""
      : "",
  };
  return result;
}
export default FormDangKySanPham;
